"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModelList = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const union_1 = __importDefault(require("lodash/union"));

const without_1 = __importDefault(require("lodash/without"));

const types_1 = require("./types");

class ModelList {
  constructor(options = {}) {
    this.addedItems = [];
    this.removedItems = [];
    this.SEARCH_QUERY_MIN_LENGTH = types_1.MODEL_LIST_CONSTANTS.SEARCH_QUERY_MIN_LENGTH;
    this.items = options.items || [];
    this.itemId = options.itemId || 'id';
  }
  /**
   * @description Method for accessing the list's items.
   * @returns {Array} a shallow clone copy of the ModelList's "items" object array
   */


  getItems() {
    return Array.from(this.items);
  }
  /**
   * @description Method for adding items to a list.
   * @param {Array} items - items to add to list
   */


  add(items) {
    const itemsToAdd = [];
    items.forEach(item => {
      const itemPendingRemove = this.removedItems.find(removed => removed[this.itemId] === item[this.itemId]);

      if (itemPendingRemove) {
        // item was pending remove (unsaved)
        this.removedItems = without_1.default(this.removedItems, itemPendingRemove);
      } else if (item[this.itemId] === undefined || // item is new
      item[this.itemId] === null || // item is new
      !this.items.some(i => i[this.itemId] === item[this.itemId]) && // item not in list of items
      !this.addedItems.some(added => added[this.itemId] === item[this.itemId]) && // item not in list of items to add
      !itemsToAdd.some(toAdd => toAdd[this.itemId] === item[this.itemId])) {
        // item not in list of items to add to list of items to add
        itemsToAdd.push(item);
      }
    });
    this.addedItems = union_1.default(this.addedItems, itemsToAdd);
  }
  /**
   * @description Method to determine if there are any unsaved changes to this
   *              list. Unsaved changes are either items pending addition or
   *              removal to/from this list since list creation or last save.
   * @returns {Boolean} true if there are unsaved changes, else false
   */


  hasUnsavedChanges() {
    return this.addedItems.length > 0 || this.removedItems.length > 0;
  }
  /**
   * @description Method to determine if an item is pending removal from this list.
   * @param {Object} item - Item to see if removal pending
   * @returns {Boolean} true if item is pending removal, else false
   */


  isPendingRemoval(item) {
    return this.removedItems.some(removed => removed[this.itemId] === item[this.itemId]);
  }
  /**
   * @description Method for removing items from a list.
   * @param {Array} items - items to remove from list
   */


  remove(items) {
    const itemsToRemove = [];
    items.forEach(item => {
      const itemPendingAdd = this.addedItems.find(added => added[this.itemId] === item[this.itemId]);

      if (itemPendingAdd) {
        // item was pending add (unsaved)
        this.addedItems = without_1.default(this.addedItems, itemPendingAdd);
      } else {
        itemsToRemove.push(item);
      }
    });
    this.removedItems = union_1.default(this.removedItems, itemsToRemove);
  }
  /**
   * @description Method to remove any items pending addition to this list.
   */


  resetAddedItems() {
    this.addedItems = [];
  }
  /**
   * @description Method to remove any items pending removal from this list.
   */


  resetRemovedItems() {
    this.removedItems = [];
  }

}

exports.ModelList = ModelList;